module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container choose-packages"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceUpgrade')))]), _vm._v(" "), _c('div', {
    staticClass: "content text-center"
  }, [_c('p', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('vipAdvantage')))]), _vm._v(" "), _c('p', {
    class: ['device-btn', {
      'change-margin': _vm.buyTip
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('numberOfDevices')))]), _vm._v(" "), _vm._l((_vm.devices), function(item) {
    return _c('button', {
      key: item,
      class: [{
        'choose-device': item === _vm.currentDevice
      }, 'line-button'],
      on: {
        "mouseover": function($event) {
          return _vm.chooseDevice(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.buyTip) ? _c('div', {
    staticClass: "buy-tip"
  }, [_vm._v(_vm._s(_vm.buyTip))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['col-' + _vm.currentCol + '-box', 'all-packages', 'packages-list-box']
  }, [_vm._l((_vm.packages), function(item, index) {
    return [_c('packageItem', {
      key: 'pkg' + index,
      attrs: {
        "item": item,
        "currentPackage": _vm.currentPackage
      },
      on: {
        "click-button": function($event) {
          return _vm.choosePackage(item, 'click')
        },
        "show-tip": _vm.showBuyTip
      },
      nativeOn: {
        "mouseover": function($event) {
          return _vm.choosePackage(item, 'mouseover')
        },
        "blur": function($event) {
          _vm.showBuyError = false
        }
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "declaration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('declaration')))]), _vm._v(" "), _vm._l((_vm.$t('declarationList')), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "declaration-list"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n        " + _vm._s(item) + "\n      ")])
  })], 2)]), _vm._v(" "), _c('created-subscription'), _vm._v(" "), _c('subscribe-result'), _vm._v(" "), _c('pay-order'), _vm._v(" "), _c('pay-redirect'), _vm._v(" "), _c('creating-order'), _vm._v(" "), _c('created-order'), _vm._v(" "), _c('top-up-result'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "subscription",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: ['modal-dialog', {
      'zh-style': _vm.language === 'zh'
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('modal-header'), _vm._v(" "), (_vm.subscriptionInfo) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('cancelSubscriptionTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "subscription-package"
  }, [_vm._v(_vm._s(_vm.$t('subscriptionPackage')) + _vm._s(_vm.subscriptionInfo.package_name))]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_vm._v(_vm._s(_vm.$t('paymentMethod')) + _vm._s(_vm.subscriptionInfo.payment_method))]), _vm._v(" "), (['iTunes', 'Google Play'].includes(_vm.subscriptionInfo.payment_method)) ? [_c('button', {
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(_vm._s(_vm.$t('back')))]), _vm._v(" "), (_vm.subscriptionInfo.payment_method === 'iTunes') ? _c('div', [_vm._v(_vm._s(_vm.$t('itunesTip')))]) : _c('div', [_vm._v(_vm._s(_vm.$t('googleTip')))])] : [(!_vm.show.cancelling) ? _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelSubscription
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelSubscription')))]) : _vm._e(), _vm._v(" "), _c('spinner-component', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.show.cancelling
    }
  }), _vm._v(" "), (_vm.cancelError) ? _c('div', {
    staticClass: "cancel-error"
  }, [_vm._v(_vm._s(_vm.cancelError))]) : _vm._e()]], 2) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23641030!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/choosePackage/ChoosePackage.vue
// module id = 1280
// module chunks = 1